var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"privacy_container"}},[_c('LandingPrivacy'),_c('b-container',{staticClass:"body",staticStyle:{"flex":"1","height":"100%"}},[_c('router-view')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }